import type { IxcGenerateV1TradeConfirmationsJobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const DOCGEN_TRADE_CONFIRMATION_JOB_BASE_PATH = getResolvedPath('/clearing/operations/generate/trade-confirmation/job');

export const getDocgenTradeConfirmationJobPath: EntityPathBuilder<IxcGenerateV1TradeConfirmationsJobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return DOCGEN_TRADE_CONFIRMATION_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.jobId) {
        return undefined;
      }

      return getResolvedPath(`${DOCGEN_TRADE_CONFIRMATION_JOB_BASE_PATH}/$jobId`, context.keys);
    }
  }
};

export function getDocgenTradeConfirmationJobDetailPath(jobId: string | undefined) {
  if (!jobId) {
    return undefined;
  }

  return getDocgenTradeConfirmationJobPath({ kind: 'detail', keys: { jobId } });
}
